import { useCallback, useState } from "react";
import Button from 'react-bootstrap/Button';
import TournamentCards from "../components/tournaments/TournamentCards";
import {useTranslation} from "react-i18next";
import NewTournamentModal from "../components/tournaments/NewTournamentModal";
import {useNavigate} from "react-router-dom";
import {getLoggedUser} from "../util/SecurityUtils";
import {useTournamentsPaged} from "../hooks/queries/useTournament";
import {useCreateTournament} from "../hooks/mutations/useTournamentMutations";
import { Icon } from "../components/common/Icon";

function Tournaments() {
    const [ showAddTournamentForm, setShowAddTournamentForm ] = useState(false)
    const [ currentPage, setCurrentPage ] = useState(0)
    const [ selectedLadder, setSelectedLadder ] = useState<string | null>(null)
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { data } = useTournamentsPaged({ page: currentPage, ladder: selectedLadder });
    const createTournament = useCreateTournament();

    const tournaments = data?.content ?? [];
    const totalPages = data?.totalPages ?? 0;

    const handleLadderChange = (ladder: string | null) => {
        setSelectedLadder(ladder);
        setCurrentPage(0);
    }

    const handleNewTournament = useCallback(async (tournament: any) => {
        const created = await createTournament.mutateAsync(tournament);
        navigate('/tournaments/' + created.id)
    }, [navigate, createTournament])

    return (
        <div className="base-container">
            <div className="table-header header">
                <span className="table-title">{t("listOfTournaments")}</span>
                {getLoggedUser() ?
                    <Button
                        variant="success"
                        size="sm"
                        onClick={() => setShowAddTournamentForm(true)}
                        className="table-button table-button-icon"
                        aria-label={t("createTournament")}
                        title={t("createTournament")}
                    >
                        <Icon name="PlusLg" />
                    </Button>
                  : null }
            </div>
            <div className="content">
                <TournamentCards
                    tournaments={tournaments}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                    selectedLadder={selectedLadder}
                    onLadderChange={handleLadderChange}
                />
            </div>
            <NewTournamentModal isOpen={showAddTournamentForm} closeModal={() => setShowAddTournamentForm(false)} handleSubmit={handleNewTournament} />
        </div>
    );
}

export default Tournaments
